<template>
  <div v-if="!isLoading">
    <nav-bar v-if="!noNav" />
    <div id="app" :class="`${carts && carts.length > 0 ? 'pad-cart' : ''} ${!noNav ? 'padding-nav' : ''}`">
      <router-view v-if="!isLoading && allProduct" />
    </div>

    <cart />

    <purchase-modal />
    <add-cart-toast />
    <modal-login />
  </div>
</template>
<script>
import store from "./store"
import { mapState } from 'vuex'
export default {
  data() {
    return {
      isLoading: true,
      dataCarts: [],
      allProduct: ""
    }
  },
  created() {
    this.$router.onReady(async () => {
      this.isLoading = true
      let loader = this.$loading.show({
        opacity: 1,
        loader: "dots",
        color: "#E9773B"
      });
      try{
        this.updateLocalStorage()
        await this.initUser()
        this.initModal()
        this.allProduct = await this.Parse.Cloud.run("MarketProduct_getAllProduct");
        localStorage.setItem('productList', JSON.stringify(this.allProduct));
        store.commit('setAllProduct' , this.allProduct)

        if(this.$route.query && this.$route.query.nonav && JSON.parse(this.$route.query.nonav) == true){
          store.commit('setNoNav' , true)
        }
        if(this.$route.query && this.$route.query.nonav && JSON.parse(this.$route.query.nonav) == true){
          // ------------------------mixpanel---------------------------
          if(this.user) this.$mixpanel.track(`market-home-webapp`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
          else this.$mixpanel.track(`market-home-webapp`)
          // -----------------------------------------------------------
        }else{
          // ------------------------mixpanel---------------------------
          if(this.user) this.$mixpanel.track(`market-home-url`, {id : this.user.id , tel : this.user.get('tel') , name : this.user.get('userProfile').get('firstName')})
          else this.$mixpanel.track(`market-home-url`)
          // -----------------------------------------------------------
        }
        this.updateVersion()
        this.isLoading = false
        loader.hide();
      }catch(error){
        console.log(error)
        this.isLoading = false
        loader.hide();
      }
    })
  },
  methods: {
    updateVersion(){
      let version = "1.0.1"
      let localVersion = localStorage.getItem('version')
      if(!localVersion || (localVersion && localVersion != version)){
        localStorage.removeItem('carts')
        localStorage.setItem('version', version);
      }
    },
    updateLocalStorage(){ // clear local storage every day
      let hours = 24
      let saved = localStorage.getItem('timeOutLocalStorage')

      if(!saved || saved == "" || saved == null ){
        localStorage.removeItem('carts');
        localStorage.setItem('timeOutLocalStorage', new Date().getTime())
      }
      if (saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) {
        localStorage.removeItem('carts');
        localStorage.setItem('timeOutLocalStorage', new Date().getTime())
      }

    },
    async initUser(){
      try {
        let user = ""
        let owners = ""
        if(this.Parse.User.current()){
          if(this.$route.query && this.$route.query.sessionToken && this.$route.query.sessionToken != "undefined" &&  this.$route.query.sessionToken != this.Parse.User.current().getSessionToken()){
            user = await this.Parse.User.become(this.$route.query.sessionToken)
          }else{
            user = await this.Parse.User.current().fetch()
          }
        }else{
          
          if(this.$route.query && this.$route.query.sessionToken && this.$route.query.sessionToken != "undefined"){
            user = await this.Parse.User.become(this.$route.query.sessionToken)
          }
        }
        if(user){
          owners = await this.Parse.Cloud.run("Owner_getByUser",{userId:user.id});
          await user.get('userProfile').fetch()
          this.$gtag.set({
            'user_id': user.id,
          })
        }

        store.commit("setUser", user)
        store.commit("setOwners", owners)

        if(this.$route.query && this.$route.query.sessionToken && this.$route.query.sessionToken != "undefined"){
          const query = Object.assign({}, this.$route.query);
          delete query.sessionToken
          await this.$router.push({ query });
        }
      } catch (err) {
        console.log(err)
        if (err.message === 'invalid session token') {
          localStorage.removeItem(`Parse/${process.env.VUE_APP_APP_KEY}/currentUser`)
          setTimeout(() =>{
            window.location.href = window.location.origin
          },200)
        }
      }
      // ------------------------mixpanel---------------------------
      this.$mixpanel.track(`market-all`)
      // -----------------------------------------------------------
    },
    initModal(){
      setTimeout(async () =>{
        if(this.$route.query && this.$route.query.purchasingType){
          if(this.$route.query.purchasingType == "single"){
            store.commit('setPurchasingProduct',JSON.parse(localStorage.getItem('purchase')))
            store.commit('setFromBuyNow',true)
            $("#main-cid-detail").addClass("modal-open");
            $("#modal-purchase").removeClass("modal-purchase-hide");
            $("body").css({"overflow-y":"hidden"})

            $("#cart-bar").addClass("hide-cart");
            $("#cart-bar").removeClass("show-cart");
          }else if(this.$route.query.purchasingType == "cart"){
            try{
              let hashProducts = {}

              for(let p of this.allProduct){
                hashProducts[p.id] = p
              }
              this.dataCarts = []

              if(localStorage.getItem('carts')){
                let localCarts = JSON.parse(localStorage.getItem('carts'))
                let balanceStore
                if(!this.hashBalanceProduct || this.hashBalanceProduct.length < 1){
                  balanceStore = await this.Parse.Cloud.run("MarketProduct_countBalanceStores",{products: localCarts.map(item => {return item.productId})});
                  store.commit('setHashBalanceProduct', balanceStore)
                }
                if(!this.carts)
                  store.commit('setCarts', localCarts)

                for(let cart of this.carts){
                  let obj = {
                    number: cart.number,
                    id: cart.productId,
                    name : hashProducts[cart.productId].get('name'),
                    image : hashProducts[cart.productId].get('images') ? hashProducts[cart.productId].get('images')[0].url() : "",
                    fullPrice : hashProducts[cart.productId].get('fullPrice'),
                    price: hashProducts[cart.productId].get('price'),
                    isIncludeVat : hashProducts[cart.productId].get('isIncludeVat'),
                    delivery : hashProducts[cart.productId].get('delivery') || 0,
                    deliveryPerNumber : hashProducts[cart.productId].get('deliveryPerNumber') || 0,
                    deliveryCategory : hashProducts[cart.productId].get('deliveryCategory'),
                    productList : hashProducts[cart.productId].get('productList') || [] , 
                    discount : hashProducts[cart.productId].get('discount') || {},
                    balanceProduct: this.hashBalanceProduct[cart.productId].balanceProduct
                  }
                  this.dataCarts.push(obj)
                }
              }

              store.commit('setFromBuyNow',false)
              $("#main-cid-detail").addClass("modal-open");
              $("#modal-purchase").removeClass("modal-purchase-hide");
              $("body").css({"overflow-y":"hidden"})
              
              $("#cart-bar").addClass("hide-cart");
              $("#cart-bar").removeClass("show-cart");
              store.commit('cartToPurchasing', this.dataCarts)

            }catch(e){
              localStorage.removeItem('carts')
            }
          }
        }
      }, 2000)
    }
  },
  computed:{
    ...mapState([
      'apartment',
      'carts',
      'hashBalanceProduct',
      'noNav'
    ]),
  }
};
</script>
<style scoped>
.pad-cart{
  margin-bottom: 30px;
}
.padding-nav{
  padding-top: 50px;
}
@media only screen and (max-width: 768px) {
  .pad-cart{
    margin-bottom: 100px;
  }
}
</style>
